import { Box, Button, Typography } from "@mui/material";
import { Flex } from "~/components/Flex";
import { Link as RouterLink } from "react-router-dom";
import { CreateTicketingIntegrationContent } from "~/pages/tickets/components/CreateTicketingIntegration/CreateTicketingIntegrationContent";
import { SpaceOrWorkspaceScope, useScope } from "~/hooks/useScope";
import { useCanCreate } from "~/lib/iam/actions/mondoo/integrations/IntegrationsManager/Create";

type CreateTicketingIntegrationProps = {
  scope: SpaceOrWorkspaceScope;
};

export const CreateTicketingIntegration = ({
  scope,
}: CreateTicketingIntegrationProps) => {
  const { spaceScope } = useScope();
  const canCreateIntegration = useCanCreate(spaceScope);
  return (
    <Box sx={{ width: "100%" }}>
      <Flex justifyContent="space-around" sx={{ mt: 10, gap: 2 }}>
        <CreateTicketingIntegrationContent />
      </Flex>
      <Flex justifyContent="center" sx={{ mt: 10 }}>
        <Button
          disabled={!canCreateIntegration}
          component={RouterLink}
          to={`/space/integrations/add?${scope.params}&redirectTo=/space/tickets?${scope.params}#ticketsystems`}
          variant="contained"
          color="primary"
          sx={{
            mt: 5,
            background: (theme) => theme.palette.primary.gradient,
            color: "common.white",
          }}
        >
          Add Integration
        </Button>
        {!canCreateIntegration && (
          <Typography component="span" sx={{ fontSize: 10 }} color="error">
            You don't have permission to create an integration.
          </Typography>
        )}
      </Flex>
    </Box>
  );
};
